import * as ACTION from './actionTypes';
import Axios from "axios"

/* start BroadcastersList */

const getAuthActionDetailsRequest = () => {
    return {
        type: ACTION.GET_AUTHACTION_DETAILS_REQUEST
    }
}

const getAuthActionDetailsSuccess = (userToken) => {
    return {
        type: ACTION.GET_AUTHACTION_DETAILS_SUCCESS,
        payload: userToken,
    }
}

const getAuthActionDetailsFailure = (errorMsg) => {
    return {
        type: ACTION.GET_AUTHACTION_DETAILS_FAILURE,
        payload: errorMsg,
    }
}

export const resetFailureMessage = () => {
    return {
        type: ACTION.RESET_FAILURE_MESSAGE
    }
}

export const getAuthActions = (userData) => {
    const apiPath = `${process.env.REACT_APP_BASE_URL}/auth`;
    return function(dispatch) {
        Axios.get(`${process.env.REACT_APP_BASE_URL}/domain-allowed/list`)
          .then((response) => {
            const rows = response?.data?.data || [];
            const validDomainList = rows
              .map((row) => (row?.domainAllowed || "").trim().toLowerCase())
              .filter(Boolean);
            const email = (userData?.username || "").trim();
            const at = email.indexOf("@");
            const domain = at > -1 ? email.slice(at + 1).trim().toLowerCase() : "";
            if (domain && validDomainList.includes(domain)) {
                dispatch(getAuthActionDetailsRequest());
                    Axios.post(apiPath, userData).then(res => {
                    localStorage.setItem("jwt_token", res?.data.jwt);
                    const headers = { Authorization: `Bearer ${res?.data.jwt}` };
                    Axios.get(
                        `${process.env.REACT_APP_BASE_URL}/accedo-detail`, {headers} )
                        .then((response) => {
                            localStorage.setItem("accedo_url", response.data.accedoApiUrl);
                            localStorage.setItem("accedo_Token", response.data.token);
                        // alert(response.accedoApiUrl);
                        })
                        .catch((error) => {
                            console.log(error);
                        });
                // Remove later if not needed, in case the Acceedo URL is the same for LIT as well.
                    // Axios.get(
                    //     `${process.env.REACT_APP_BASE_URL}/lit/accedo-detail`, {headers} )
                    //     .then((response) => {
                    //         if (response.data.litAccedoApiUrl) {
                    //             localStorage.setItem("lit_accedo_url", response.data.litAccedoApiUrl);
                    //             localStorage.setItem("lit_accedo_Token", response.data.litToken);
                    //         }
                    //     })
                    //     .catch((error) => {
                    //         console.log("LIT accedo-detail not available:", error?.message);
                    //     });
                    const username = res?.data?.userDetails?.userName;
                    Axios.get(
                        `${process.env.REACT_APP_BASE_URL}/user-project?username=${encodeURIComponent(username)}`,
                        { headers }
                    )
                        .then((projectRes) => {
                            const userProjects = projectRes?.data?.data || [];
                            localStorage.setItem("userProjects", JSON.stringify(userProjects));
                            dispatch(getAuthActionDetailsSuccess({ data: res.data, userProjects }));
                        })
                        .catch(() => {
                            localStorage.setItem("userProjects", JSON.stringify([]));
                            dispatch(getAuthActionDetailsSuccess({ data: res.data, userProjects: [] }));
                        });
                    
                })
                .catch(err => {
                    dispatch(getAuthActionDetailsFailure(err?.response?.data?.errorMessage));
                    // console.log(err)
                });
            }
            else {
                const msg =
                  validDomainList.length === 0
                    ? "No allowed email domains are configured on the server. Please contact your administrator."
                    : domain
                      ? `Email domain "${domain}" is not allowed. Allowed domains: ${validDomainList.join(", ")}.`
                      : "Enter a valid email address (user@domain.com).";
                dispatch(getAuthActionDetailsFailure(msg));
            }
          })
          .catch((error) => {
            const base = process.env.REACT_APP_BASE_URL || "(REACT_APP_BASE_URL not set)";
            const serverMsg = error?.response?.data?.errorMessage;
            const netMsg =
              error?.code === "ERR_NETWORK" || error?.message === "Network Error"
                ? "Network error — server may be down, wrong URL, or browser blocked the request (CORS)."
                : error?.message;
            dispatch(
              getAuthActionDetailsFailure(
                serverMsg ||
                  `Could not load allowed domains from ${base}. ${netMsg || "Check that STBService is running and this URL matches your backend (see .env.development for local)."}`)
            );
          });
    };
};
